import { render, staticRenderFns } from "./selectvalues.vue?vue&type=template&id=a5b6053e&"
import script from "./selectvalues.vue?vue&type=script&lang=js&"
export * from "./selectvalues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports